import UISection from 'UIComponents/section/UISection';
import { isFilterEmpty } from 'automation-ui-flow-core/enrollment/enrollmentUtils';
import ListSegmentationFilters from 'automation-ui-enrollment/components/common/ListSegmentationFilters';
import { jsx as _jsx } from "react/jsx-runtime";
const EnrollmentFilterViewer = ({
  emptyFilterMessage,
  objectTypeId,
  value
}) => {
  if (isFilterEmpty(value)) {
    return emptyFilterMessage;
  }
  return /*#__PURE__*/_jsx(UISection, {
    children: /*#__PURE__*/_jsx(ListSegmentationFilters, {
      objectTypeId: objectTypeId,
      readOnly: true,
      value: value
    })
  });
};
export default EnrollmentFilterViewer;